import { serviceClient } from 'lib/api/client';

export const getDashboardCounts = () => serviceClient.get('/dashboard');

export const getStoreList = () => serviceClient.get('/store/company');

export const getStoreSensorList = spaceId =>
  serviceClient.get(`/dashboard/store/${spaceId}/sensor`);

export const getSensorData = slaveId =>
  serviceClient.get(`/dashboard/sensor/${slaveId}/detail`);

export const getControllerList = (filter, storeId = '') =>
  serviceClient.get(
    `/dashboard/store/controller?filter=${filter}&filterValue=${storeId}`,
  );

export const getNotis = async ({
  pageParam = 1,
  filter,
  filterValue = 0,
  startDate,
  endDate,
}) => {
  if (filter === 0) {
    const response = await serviceClient.get(
      `/dashboard/notification?page=${pageParam}&limit=10&filter=${filter}&filterValue=${filterValue}`,
    );
    const result = response.data;

    return {
      result: result.rows,
      nextPage: pageParam + 1,
      isLast: result.count / 10 < pageParam,
    };
  }

  const response = await serviceClient.get(
    `/dashboard/notification?page=${pageParam}&limit=10&filter=${filter}&filterValue=${filterValue}&startDate=${startDate}&endDate=${endDate}`,
  );

  const result = response.data;

  return {
    result: result.rows,
    nextPage: pageParam + 1,
    isLast: result.count / 10 < pageParam,
  };
};
